import { render, staticRenderFns } from "./Svg.vue?vue&type=template&id=4ae3ca93&scoped=true"
import script from "./Svg.vue?vue&type=script&lang=js"
export * from "./Svg.vue?vue&type=script&lang=js"
import style0 from "./Svg.vue?vue&type=style&index=0&id=4ae3ca93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae3ca93",
  null
  
)

export default component.exports